import { Form } from "antd";
import {
  convertDataToDataForm,
  buildTreeAppPartType,
} from "@lhd/components/CloneApp/untils";

import { AppRecordV2, AppV2, AppSelectionList } from "@lhd/types";
import { APP_PART_TYPES } from "@lhd/features/Apps/AppForm/constants";
import TableCusTom from "@lhd/components/CloneApp/fields/TableCusTom";
import { useMemo } from "react";
import { Styles } from "./styled";
import { useGetSelectOptionByAppPartType } from "@lhd/hooks";

interface IProps {
  dataApp: AppV2;
  appRecord: AppRecordV2;
  selectionDataList?: AppSelectionList;
}

const RegulationPDF = ({
  dataApp,
  appRecord,
  selectionDataList: selectionDataListProps,
}: IProps) => {
  const [form] = Form.useForm();

  // Prepare full tree to find parts and use in hooks
  const appPartsFlat = useMemo(
    () => dataApp?.app_parts?.filter((x) => !!x.item_config_data) || [],
    [dataApp.app_parts],
  );

  const appPartsTree = useMemo(
    () => buildTreeAppPartType(appPartsFlat),
    [appPartsFlat],
  );

  const fetchedSelectionDataList =
    useGetSelectOptionByAppPartType(appPartsTree);
  const selectionDataList = selectionDataListProps || fetchedSelectionDataList;

  // Set form values
  useMemo(() => {
    if (appRecord) {
      const result = convertDataToDataForm(
        dataApp?.app_parts || [],
        appRecord,
        true,
      );

      form.setFieldsValue(result);
    }
  }, [appRecord, dataApp, form]);

  // Find the companyPolice Name for the title
  const companyPoliceName = useMemo(() => {
    const namePart = appPartsFlat.find(
      (part) => part.label_text === "規程名" || part.name === "規程名",
    );
    if (namePart) {
      const val = appRecord?.regular_values?.find(
        (v) => Number(v.app_part_id) === Number(namePart.id),
      );
      if (val?.value) return val.value;
    }
    return dataApp?.name || "規程";
  }, [appPartsFlat, appRecord, dataApp]);

  // Find and filter the table

  const filteredTablePart = useMemo(() => {
    // Look for the table in the tree (usually it's a root part or nested)
    // We'll search recursively or just find the first table part
    const findTable = (parts: any[]): any => {
      for (const part of parts) {
        if (part.app_part_type === APP_PART_TYPES.TABLE) return part;
        if (part.children?.length) {
          const found = findTable(part.children);
          if (found) return found;
        }
      }
      return null;
    };

    const tablePart = findTable(appPartsTree);
    if (!tablePart) return null;

    // Requirement: Filter columns (e.g., take the first 6 columns)
    const sortedChildren = [...(tablePart.children || [])].sort(
      (a, b) => a.item_config_data.x - b.item_config_data.x,
    );

    // Skip index 0 (STT), take next 6 (indices 0 to 5)
    const filteredChildren = sortedChildren.slice(0, 6);

    return {
      ...tablePart,
      children: filteredChildren,
    };
  }, [appPartsTree]);

  return (
    <Form form={form} disabled>
      <Styles>
        <div className="pdf-container page">
          <h1 className="pdf-title">{companyPoliceName}</h1>
          {filteredTablePart && (
            <div className="pdf-table-wrapper">
              <TableCusTom
                item={filteredTablePart}
                selectionDataList={selectionDataList}
                isPDF={true}
                isDisabled={true}
              />
            </div>
          )}
        </div>
      </Styles>
    </Form>
  );
};

export default RegulationPDF;
